import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Package, ChevronRight } from 'lucide-react';
import Header24 from './components/Header24';
import Footer24 from './components/Footer24';

const Orders24 = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('all');

    const orders = [
        {
            id: 'DHR-2026-0847',
            date: 'March 12, 2026',
            status: 'Delivered',
            total: 14500,
            items: [
                { name: 'Silk Chanderi Drape', size: 'M', price: 14500, image: 'https://images.pexels.com/photos/8980747/pexels-photo-8980747.jpeg?auto=compress&cs=tinysrgb&w=200' },
            ],
        },
        {
            id: 'DHR-2026-0732',
            date: 'February 28, 2026',
            status: 'In Transit',
            total: 30100,
            items: [
                { name: 'Heritage Banarasi Sari', size: 'S', price: 22000, image: 'https://images.pexels.com/photos/8285483/pexels-photo-8285483.jpeg?auto=compress&cs=tinysrgb&w=200' },
                { name: 'The Monsoon Kurta', size: 'M', price: 7800, image: 'https://images.pexels.com/photos/6712369/pexels-photo-6712369.jpeg?auto=compress&cs=tinysrgb&w=200' },
            ],
        },
        {
            id: 'DHR-2026-0615',
            date: 'January 15, 2026',
            status: 'Delivered',
            total: 8800,
            items: [
                { name: 'Linen Summer Set', size: 'L', price: 8800, image: 'https://images.pexels.com/photos/6765003/pexels-photo-6765003.jpeg?auto=compress&cs=tinysrgb&w=200' },
            ],
        },
    ];

    const tabs = [
        { key: 'all', label: 'All Orders' },
        { key: 'transit', label: 'In Transit' },
        { key: 'delivered', label: 'Delivered' },
    ];

    const filteredOrders = activeTab === 'all'
        ? orders
        : orders.filter(o => {
            if (activeTab === 'transit') return o.status === 'In Transit';
            if (activeTab === 'delivered') return o.status === 'Delivered';
            return true;
        });

    const getStatusColor = (status) => {
        switch (status) {
            case 'Delivered': return '#00553A';
            case 'In Transit': return '#B8860B';
            case 'Processing': return '#6B6B6B';
            default: return '#6B6B6B';
        }
    };

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Inter:wght@300;400;500;600;700&display=swap');

                .dhara-orders {
                    min-height: 100vh;
                    background: #FFFFFF;
                }
                .dhara-orders-inner {
                    max-width: 900px;
                    margin: 0 auto;
                    padding: 60px 40px 120px;
                }
                .dhara-orders-title {
                    font-family: 'Playfair Display', serif;
                    font-size: 42px;
                    font-weight: 400;
                    color: #1A1A1A;
                    margin-bottom: 48px;
                    letter-spacing: -0.5px;
                }
                .dhara-orders-tabs {
                    display: flex;
                    gap: 32px;
                    border-bottom: 1px solid #E5E5E5;
                    margin-bottom: 48px;
                }
                .dhara-orders-tab {
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    font-weight: 400;
                    letter-spacing: 0.5px;
                    color: #6B6B6B;
                    padding: 12px 0;
                    border: none;
                    background: none;
                    cursor: pointer;
                    position: relative;
                    transition: color 0.3s ease;
                }
                .dhara-orders-tab.active {
                    color: #1A1A1A;
                }
                .dhara-orders-tab.active::after {
                    content: '';
                    position: absolute;
                    bottom: -1px;
                    left: 0;
                    right: 0;
                    height: 1px;
                    background: #1A1A1A;
                }
                .dhara-orders-tab:hover {
                    color: #1A1A1A;
                }

                .dhara-order-card {
                    border: 1px solid #E5E5E5;
                    padding: 32px;
                    margin-bottom: 24px;
                    transition: border-color 0.3s ease;
                }
                .dhara-order-card:hover {
                    border-color: #BDBDBD;
                }
                .dhara-order-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    margin-bottom: 24px;
                }
                .dhara-order-id {
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    font-weight: 500;
                    color: #1A1A1A;
                    margin-bottom: 4px;
                }
                .dhara-order-date {
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    color: #6B6B6B;
                }
                .dhara-order-status {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    font-weight: 500;
                }
                .dhara-order-status-dot {
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                }
                .dhara-order-items {
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                    margin-bottom: 24px;
                }
                .dhara-order-item {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                }
                .dhara-order-item-img {
                    width: 64px;
                    height: 80px;
                    object-fit: cover;
                    background: #FAFAF8;
                }
                .dhara-order-item-name {
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    color: #1A1A1A;
                    margin-bottom: 4px;
                }
                .dhara-order-item-size {
                    font-family: 'Inter', sans-serif;
                    font-size: 12px;
                    color: #6B6B6B;
                }
                .dhara-order-item-price {
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    color: #1A1A1A;
                    margin-left: auto;
                }
                .dhara-order-footer {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding-top: 20px;
                    border-top: 1px solid #E5E5E5;
                }
                .dhara-order-total-label {
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    color: #6B6B6B;
                }
                .dhara-order-total {
                    font-family: 'Inter', sans-serif;
                    font-size: 16px;
                    font-weight: 500;
                    color: #1A1A1A;
                }
                .dhara-order-view {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    color: #00553A;
                    background: none;
                    border: none;
                    cursor: pointer;
                    transition: opacity 0.3s ease;
                    padding: 0;
                }
                .dhara-order-view:hover {
                    opacity: 0.7;
                }

                .dhara-orders-empty {
                    text-align: center;
                    padding: 80px 20px;
                }
                .dhara-orders-empty-icon {
                    color: #E5E5E5;
                    margin-bottom: 24px;
                }
                .dhara-orders-empty-title {
                    font-family: 'Playfair Display', serif;
                    font-size: 24px;
                    color: #1A1A1A;
                    margin-bottom: 12px;
                }
                .dhara-orders-empty-text {
                    font-family: 'Inter', sans-serif;
                    font-size: 15px;
                    color: #6B6B6B;
                    margin-bottom: 32px;
                }
                .dhara-orders-shop-btn {
                    display: inline-block;
                    padding: 14px 40px;
                    background: #00553A;
                    color: #FFFFFF;
                    border: none;
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    font-weight: 500;
                    letter-spacing: 1.5px;
                    text-transform: uppercase;
                    cursor: pointer;
                    transition: background 0.3s ease;
                }
                .dhara-orders-shop-btn:hover {
                    background: #006B4A;
                }

                @media (max-width: 768px) {
                    .dhara-orders-inner { padding: 40px 20px 80px; }
                    .dhara-orders-title { font-size: 32px; }
                    .dhara-order-card { padding: 20px; }
                    .dhara-order-header { flex-direction: column; gap: 12px; }
                }
            `}</style>

            <Header24 />

            <main className="dhara-orders">
                <div className="dhara-orders-inner">
                    <h1 className="dhara-orders-title">Your Orders</h1>

                    <div className="dhara-orders-tabs">
                        {tabs.map(tab => (
                            <button
                                key={tab.key}
                                className={`dhara-orders-tab ${activeTab === tab.key ? 'active' : ''}`}
                                onClick={() => setActiveTab(tab.key)}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>

                    {filteredOrders.length === 0 ? (
                        <div className="dhara-orders-empty">
                            <Package size={48} strokeWidth={1} className="dhara-orders-empty-icon" />
                            <h2 className="dhara-orders-empty-title">No orders yet</h2>
                            <p className="dhara-orders-empty-text">
                                Your order history will appear here once you make your first purchase.
                            </p>
                            <button
                                className="dhara-orders-shop-btn"
                                onClick={() => navigate('/template24/shop')}
                            >
                                Start Shopping
                            </button>
                        </div>
                    ) : (
                        filteredOrders.map(order => (
                            <div key={order.id} className="dhara-order-card">
                                <div className="dhara-order-header">
                                    <div>
                                        <div className="dhara-order-id">{order.id}</div>
                                        <div className="dhara-order-date">{order.date}</div>
                                    </div>
                                    <div
                                        className="dhara-order-status"
                                        style={{ color: getStatusColor(order.status) }}
                                    >
                                        <div
                                            className="dhara-order-status-dot"
                                            style={{ background: getStatusColor(order.status) }}
                                        />
                                        {order.status}
                                    </div>
                                </div>
                                <div className="dhara-order-items">
                                    {order.items.map((item, i) => (
                                        <div key={i} className="dhara-order-item">
                                            <img className="dhara-order-item-img" src={item.image} alt={item.name} />
                                            <div>
                                                <div className="dhara-order-item-name">{item.name}</div>
                                                <div className="dhara-order-item-size">Size: {item.size}</div>
                                            </div>
                                            <div className="dhara-order-item-price">
                                                {'\u20B9'}{item.price.toLocaleString('en-IN')}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="dhara-order-footer">
                                    <div>
                                        <div className="dhara-order-total-label">Total</div>
                                        <div className="dhara-order-total">
                                            {'\u20B9'}{order.total.toLocaleString('en-IN')}
                                        </div>
                                    </div>
                                    <button className="dhara-order-view">
                                        View Details
                                        <ChevronRight size={16} strokeWidth={1.5} />
                                    </button>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </main>

            <Footer24 />
        </>
    );
};

export default Orders24;
